import { useState, useEffect } from "react";

import { useSelector } from "react-redux";

import { Chart } from "devextreme-react";
import {
  ArgumentAxis,
  CommonSeriesSettings,
  Connector,
  Grid,
  Label,
  Series,
  Tick,
  Title,
  ValueAxis,
} from "devextreme-react/chart";

import axios from "axios";

export default function ChartItem() {
  const chartType = useSelector((state) => state.chartType);
  const series = useSelector((state) => state.series);
  const axis = useSelector((state) => state.axis);
  const axisTitle = useSelector((state) => state.axisTitle);
  const chartTitle = useSelector((state) => state.chartTitle);
  const dataLabel = useSelector((state) => state.dataLabel);
  const grid = useSelector((state) => state.grid);

  const [dataSource, setDataSource] = useState(null);

  useEffect(() => {
    axios
      .post(
        `${process.env.REACT_APP_BECCO_API_URL}/api/mdcinClincTestInfoService01/VIS_DATA`,
        {
          argumentField: series.argumentField,
          commonSeries: series.commonSeries,
          series: series.series,
          valueField: series.valueField,
        }
      )
      .then((result) => {
        setDataSource(result.data);
      });
  }, [series]);

  const customizeText = (pointInfo) => {
    if (dataLabel.customizeText) {
      return `${pointInfo.argumentText}, ${pointInfo.valueText}`;
    } else {
      return `${pointInfo.valueText}`;
    }
  };

  return (
    <Chart dataSource={dataSource}>
      {chartTitle.exist && (
        <Title
          text={chartTitle.text}
          horizontalAlignment={chartTitle.horizontalAlignment}
          verticalAlignment={chartTitle.verticalAlignment}
        />
      )}

      <CommonSeriesSettings
        type={chartType.subtype}
        argumentField={series.argumentField}
      >
        <Label
          visible={dataLabel.exist}
          alignment={dataLabel.alignment}
          position={dataLabel.position}
          customizeText={customizeText}
        />
      </CommonSeriesSettings>

      {series.series.map((s, index) => {
        return <Series key={s.id} valueField={s.value} name={s.name} />;
      })}

      <ArgumentAxis>
        <Tick visible={axis.defaultLandscape} />
        <Label visible={axis.defaultLandscape} />
        <Title
          text={axisTitle.defaultLandscape ? axisTitle.landscapeTitle : null}
        />
      </ArgumentAxis>

      <ValueAxis>
        <Tick visible={axis.defaultVertical} />
        <Label visible={axis.defaultVertical} />
        <Title
          text={axisTitle.defaultVertical ? axisTitle.verticalTitle : null}
        />
        <Grid visible={grid.valueAxisGrid} />
      </ValueAxis>
    </Chart>
  );
}
